import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ManualFlowEffects } from './manual-flow.effects';
import { manualFlowFeature } from './manual-flow.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(manualFlowFeature), EffectsModule.forFeature([ManualFlowEffects])],
})
export class ManualFlowStateModule {}
